import {useRoute} from 'wouter';

/*
    types of URLs supported:
    - /<documentId>/@<nodeId>
    - /<documentId>/revisions/<revisionId>/@<nodeId>
    should work in both edit and explore modes
*/
export function useUrlNodeId() {
    const [, nodeMatch] = useRoute<{nodeId?: string}>(
        new RegExp(
            '^/(?<documentId>[^/]+)/(?:revisions/(?<revisionId>[^/]+)/)?@(?<nodeId>[^/]+)/?$'
        )
    );

    return nodeMatch?.nodeId && decodeURIComponent(nodeMatch.nodeId);
}
